module.exports = __webpack_public_path__ + "media/Intro_NoLyrics.2d108e1b.mp3";